import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import DownloadReportButton from "../../../../../components/DownloadReportButton";
import YearMonthRangePicker from "../../../../../components/YearMonthRangePicker";

const StatsControls = ({
	disableBranchSelect,
	onBranchChange,
	branchValue,
	branchOptions,
	onRangeChange,
	rangeValue,
	weightFrom,
	onWeightFromChange,
	weightTo,
	onWeightToChange,
	isLoading,
	onSubmit,
}) => {
	const todayYear = new Date().getFullYear();
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: "30px",
				position: "relative",
				zIndex: "50",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label" htmlFor="branch-select">
						{t("branch")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
					<FormControl fullWidth margin="none">
						<Select
							labelId="branch-select"
							onChange={onBranchChange}
							value={branchValue}
							size="small"
							displayEmpty
							disabled={disableBranchSelect}
						>
							{[{ value: "", label: t("all") }, ...branchOptions].map(
								(option) => (
									<MenuItem key={option.value} value={option.value}>
										{option.label}
									</MenuItem>
								)
							)}
						</Select>
					</FormControl>
				</Box>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label" htmlFor="month-select">
						{t("month")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
					<FormControl fullWidth margin="none">
						<YearMonthRangePicker
							onChange={onRangeChange}
							value={rangeValue}
							minDate={new Date(2020, 0)}
							maxDate={new Date(todayYear, 0)}
						/>
					</FormControl>
				</Box>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label">
						{t("cargos_label")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightFrom"
						sx={{ color: "#7F7F7F" }}
					>
						{t("from")}
					</Typography>
					<TextField
						id="weightFrom"
						size="small"
						value={weightFrom}
						variant="outlined"
						onChange={onWeightFromChange}
						sx={{ width: "80px" }}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightTo"
						sx={{ color: "#7F7F7F" }}
					>
						{t("to")}
					</Typography>
					<TextField
						id="weightTo"
						size="small"
						value={weightTo}
						variant="outlined"
						sx={{ width: "80px" }}
						onChange={onWeightToChange}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
			</Box>
			<Box>
				<Button
					loading={isLoading}
					onClick={onSubmit}
					type="button"
					fullWidth
					variant="contained"
				>
					{t("change")}
				</Button>
			</Box>
			<Box>
				<DownloadReportButton
					slug="/api/company/stats/relation/downloadReport"
					text={t("download_full_report")}
				/>
			</Box>
		</Box>
	);
};

export default StatsControls;
